/**
 * EmailPolishChanges: what Polish touched, under the polished email. One
 * short line per correction; "Your email is ready as written" when the email was clean.
 */

import type { ReactNode } from 'react';

export function EmailPolishChanges({ changes }: { changes: readonly string[] }): ReactNode {
  return (
    <section
      className="rounded-card bg-paper p-5 shadow-sh1"
      aria-label="What changed"
      data-testid="email-polish-changes"
    >
      <h3 className="text-label font-semibold uppercase tracking-[0.16em] text-sage-400">
        What changed
      </h3>
      {changes.length === 0 ? (
        <p className="mt-2 text-sm text-ink-soft">Your email is ready as written.</p>
      ) : (
        <ul className="mt-2 space-y-1 text-sm text-ink">
          {changes.map((change, i) => (
            <li key={i}>{change}</li>
          ))}
        </ul>
      )}
    </section>
  );
}
